<template>
  <google-map-loader :mapConfig="mapConfig" :apiKey="apiKey">
    <!-- This are the props exposed from the child component -->
    <template slot-scope="{ google, map }">
      <google-map-marker
        v-for="marker in markers"
        :key="marker.id"
        :marker="marker"
        :google="google"
        :map="map"
      />
      <google-map-line
        v-for="line in lines"
        :key="line.id"
        :path.sync="line.path"
        :google="google"
        :map="map"
      />
    </template>
  </google-map-loader>
</template>
<script>
import GoogleMapLoader from "./GoogleMapLoader";
import GoogleMapMarker from "./GoogleMapMarker";
import GoogleMapLine from "./GoogleMapLine";
import { mapSettings } from "../constants/mapSettings";

export default {
  components: {
    GoogleMapLoader,
    GoogleMapMarker,
    GoogleMapLine,
  },

  computed: {
    mapConfig() {
      return {
        ...mapSettings,
        center: this.mapCenter,
      };
    },
    mapCenter() {
      return this.markers[0].position;
    },
  },
  data() {
    return {
      /*   Enter the Appropriate Key for the Maps API
       *   Required API's to be Enabled are :-
       *   1) Maps Javascript API
       *   2) Places API
       */

      apiKey: "AIzaSyDqvWv-MWSIGPOs_G1_m8jMtIosRqbRYGU",
      markers: [],
      lines: [
        {
          id: "1",
          path: [
            { lat: 3, lng: 101 },
            { lat: 5, lng: 99 },
          ],
        },
        {
          id: "2",
          path: [
            { lat: 5, lng: 99 },
            { lat: 6, lng: 97 },
          ],
        },
      ],
    };
  },
  props: {
    point: {
      type: Object,
      required: false,
    },
  },
  watch: {
    point: {
      immediate: true,
      handler(value) {
        if (value) {
          var lat = parseInt(value.lat);
          var long = parseInt(value.long);
          this.markers.push({
            id: Math.random().toString(), // using random number to avoid duplicate key
            position: { lat: lat, lng: long },
          });
        } else {
          // Defaults to Addis Ababa
          this.markers.push({
            id: Math.random().toString(),
            position: { lat: 9.02497, lng: 38.74689 },
          });
        }
      },
    },
  },
};
</script>